import { useSuspenseQuery } from '@apollo/client';
import { GET_OPERATIONAL_STATE } from '../graphql/queries/getOperationalState';

export const useOperationalState = (deviceId: string) => {
  const { data } = useSuspenseQuery(GET_OPERATIONAL_STATE, {
    variables: { deviceId },
  });

  return data.device.profile;
};
